import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './navigation';
import { useEffect } from 'react';
import { initAnalytics, logPageView } from './utils/analytics/analytics';
import useDevToolsBlocker from './hooks/devToolsBlocker/useDevToolsBlocker';

//
function App() {

  useDevToolsBlocker();


  useEffect(() => {
    initAnalytics();
    logPageView();
  }, []);



  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
